import { render, staticRenderFns } from "./BotSelector.vue?vue&type=template&id=2378c909&"
import script from "./BotSelector.vue?vue&type=script&lang=js&"
export * from "./BotSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports